import React, { useContext } from 'react'

export const Labels = React.createContext({});

export const useExtLabels = () => {
    const labels = useContext(Labels)
    return (key) => {
        const val = labels[key]
        return val && val !== '' ? val : key
    }
}
